module.exports = __webpack_public_path__ + "3a52e2f9421b859c305c05e51d354b63.MP3";